<div class="container">
  <div class="container-lottie">
    <ng-lottie
      [width]=""
      [height]=""
      [options]="gif"
      style="width: 50%;"
    ></ng-lottie>
  </div>
  <div class="condainer-label">
    <label>{{ 'AUTENTICACION.MSG_SEPRESENTOERROR' | translate }}</label>
  </div>
  <div class="grid form-footer-buttons">
    <div class="form-group col-12">
      <button icon="fa fa-close" type="button"
              class="ibtn" (click)="cerrar()">{{ 'BTN_CERRAR' | translate }}</button>
    </div>
  </div>
</div>
